// Firebase 
import {initializeApp} from "firebase/app";
import firebaseConfig from "./config/FirebaseConfig";

import {
GoogleAuthProvider,
getAuth,
signInWithPopup,
signInWithEmailAndPassword,
createUserWithEmailAndPassword,
sendPasswordResetEmail,
signOut,
} from "firebase/auth";

import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from "firebase/firestore";

// Modules
import {useDispatch} from "react-redux";

// MACROS
const GOOGLE = "google" ;
const LOCAL  = "local"  ;

// initialization to Firebase 
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Google Authentication : Login 
const googleProvider = new GoogleAuthProvider() ; 

// sign in with Google
const signInWithGoogle = async () => {

	try {
		// we are trying to do sign in via Google
		const res = await signInWithPopup(auth,googleProvider);
		console.log(res);
		const user = res.user ; 
		console.log(user);
		const q = query(collection(db,"users"),where("uid","==",user.uid));
		console.log(q);
		const userDoc = await getDocs(q);
		console.log(userDoc);

		// if user is new to the app we make a new record for future reference
		if(userDoc.docs.length == 0){
			await addDoc(collection(db,"users"),{
				uid : user.uid , 
				name : user.displayName,
				authProvider : GOOGLE,
				email : user.email,
			});
		}

	} catch(err) {
		// if authentication fails
		console.log(err);
		alert(err);
	}

};

// Email And Password Authentication : Login
const loginWithEmailAndPassword = async (email,password) => {
	try {

		// we are trying to do login via email and password
		await signInWithEmailAndPassword(auth,email,password);

	}catch(err){
		// if authentication fails
		console.log(err);
		alert(err);
	}
}

// Email and Password Authentication : Sign up
const signupWithEmailAndPassword = async(email,password) => {
	try {

		const res = await createUserWithEmailAndPassword(auth,email,password);
		const user = res.user ;
		await addDoc(collection(db,"users"),{
				uid : user.uid , 
				name : user.displayName,
				authProvider : LOCAL,
				email,
		});


	}catch(err){
		// if sign up fails
		console.log(err);
		alert(err);
	}
}

// Reset Password
const sendPasswordReset = async (email) => {
	try {
		await sendPasswordResetEmail(auth,email);	
		alert(`Password Reset Link has been sent to ${email}`);
	}catch(err){
		console.log(err);
		alert(err);
	}
}

// Logout
const logout = async () => {
	try {
		await signOut(auth).then(()=>{
			console.log("Signout Successful");
		}).catch((err)=>{
			console.log("Signout : Error");
		})

	}catch(err){
		console.log(err);
		alert(err);
	}
};

// export modules
export {
	auth,
	db,
	signInWithGoogle,
	loginWithEmailAndPassword,
	signupWithEmailAndPassword,
	sendPasswordReset,
	logout,
};